import { useEffect, type ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { warmEventRequests } from '@/lib/api/warmEventRequests';

function storedRole(): string | undefined {
  try {
    return JSON.parse(localStorage.getItem('user') ?? 'null')?.role;
  } catch {
    return undefined;
  }
}

/**
 * Wraps the event route OUTSIDE the auth guard, so the page's requests start at mount instead of
 * after /auth/me and the event load. The role comes from the last login (auth isn't known yet).
 */
export default function EventRequestsWarmup({ children }: { children: ReactNode }) {
  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    if (id) warmEventRequests(id, storedRole());
  }, [id]);
  return <>{children}</>;
}
